import React from 'react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { confirmDatasetsDeletion, refreshDatasets } from '../actions';
import { datasetAdminPermissions } from '../sharing/constants';

const DatasetsActions = ({
  allowCreate,
  allowDelete,
  allowRefresh,
  category,
  code,
  disableDelete,
  readStatus,
  refresh,
  showDelete,
}) => (
  <>
    {allowCreate && (<CreateAction url={codeUrl(urls.DATASET, code, '#')} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={disableDelete} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  datasets: { datasets, newDatasetCode },
}, { category }) => {
  const { readStatus } = datasets[category];
  const selected = findSelectedInCategory(datasets, category);
  const denyDestroy = selected.some((dataset) => !dataset.permissions[datasetAdminPermissions.DESTROY]);

  return {
    allowCreate: permissions.datasets.create,
    allowDelete: permissions.datasets.destroy,
    allowRefresh: permissions.datasets.read,
    code: newDatasetCode,
    disableDelete: denyDestroy || readStatus === states.PENDING || selected.length === 0,
    readStatus,
  };
};

const mapDispatchToProps = {
  refresh: refreshDatasets,
  showDelete: confirmDatasetsDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetsActions);
